import { type ScrapedUser } from "@/lib/scraper";

/**
 * Display-name resolver shared across the Audience surfaces (table, drawer).
 * Prefers @username, then full name, then a stable id fallback.
 */
export function userDisplayName(user: ScrapedUser): string {
  if (user.username) return `@${user.username}`;
  const full = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return full || `id:${user.tg_user_id}`;
}
